<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-card outlined tile flat>
          <v-layout wrap justify-center>
            <v-flex xs12 text-left pt-4 px-2>
              <span
                style="
                  font-family: poppinssemibold;
                  font-size: 15px;
                  color: #000000;
                "
              >
                Top Reviews
              </span>
            </v-flex>
            <v-flex xs12 sm6 md6 lg12 xl12>
              <v-layout wrap justify-center>
                <v-flex xs12 v-for="(item, i) in reviews" :key="i" py-2>
                  <v-layout wrap justify-center>
                    <v-flex xs2 pl-2>
                      <v-avatar size="26">
                        <img :src="mediaURL + item.image" />
                      </v-avatar>
                    </v-flex>
                    <v-flex xs10 pl-4>
                      <v-layout wrap justify-center style="line-height: 12px">
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: poppinsregular;
                              font-size: 11px;
                              color: #000000;
                            "
                            >{{ item.name }}</span
                          >
                        </v-flex>
                        <v-flex xs12 text-left>
                          <v-rating
                            v-model="item.rating"
                            color="#FFD341"
                            background-color="#e0e0e0"
                            empty-icon="$ratingFull"
                            half-increments
                            hover
                            small
                            readonly
                          ></v-rating>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span
                            style="
                              font-family: poppinslight;
                              font-size: 10px;
                              color: #7d7d7d;
                            "
                            >{{ item.comment }}</span
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap justify-center pt-2>
                    <v-flex xs10>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm6 md6 lg12 xl12 py-2>
              <v-layout wrap justify-center px-2>
                <v-flex xs12 text-left>
                  <span
                    style="
                      font-family: poppinssemibold;
                      font-size: 12px;
                      text-transform: none;
                    "
                  >
                    Your Rating
                  </span>
                  <v-rating
                    v-model="rating"
                    color="#FFD341"
                    background-color="#e0e0e0"
                    empty-icon="$ratingFull"
                    half-increments
                    hover
                    small
                  ></v-rating>
                </v-flex>
                <v-flex xs12 pt-2>
                  <v-textarea
                    v-model="comment"
                    outlined
                    rows="3"
                    label="Comments"
                    hide-details
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 pt-2>
                  <v-btn
                    :ripple="false"
                    depressed
                    dark
                    block
                    tile
                    color="#FF1313"
                    :loading="ratingLoading"
                    @click="addRating"
                  >
                    <span
                      style="
                        font-family: poppinssemibold;
                        font-size: 12px;
                        text-transform: none;
                      "
                    >
                      Add Review
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm6 md6 lg12 xl12 pt-2 v-if="styleImage">
              <v-img v-if="styleImage" :src="mediaURL + styleImage">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="#FF2323"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <!-- <v-img v-else src="./../../assets/rejected.svg"></v-img> -->
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["styleId"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      reviews: [],
      rating: 0,
      comment: null,
      ratingLoading: false,
    };
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    styleImage() {
      var newImage;
      // for (var i = 0; i < this.stylCategories.length; i++) {
      //   if (this.styleId == this.stylCategories[i]._id)
      //     newImage = this.stylCategories[i].image;
      // }
      return newImage;
    },
    // stylCategories() {
    //   return this.$store.state.stylCategories;
    // },
  },
  beforeMount() {
    this.getData();
    if (this.appLogin) this.getRating();
    // this.$store.dispatch("getStylCategory");
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/topreview/getlist",
      })
        .then((response) => {
          this.appLoading = false;
          this.reviews = response.data.data;
          for (var i = 0; i < this.reviews.length; i++) {
            this.reviews[i].rating = Number(this.reviews[i].rating);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },

    getRating() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/home/review/mine",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.rating = response.data.data.rating;
            this.comment = response.data.data.comment;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    addRating() {
      if (!this.appLogin) {
        this.msg = "Please login to add rating";
        this.showSnackBar = true;
        return;
      }
      this.ratingLoading = true;
      var review = {};
      review["rating"] = this.rating;
      review["comment"] = this.comment;
      review["edit"] = true;
      axios({
        method: "POST",
        url: "/home/review/add",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: review,
      })
        .then((response) => {
          this.ratingLoading = false;
          this.msg = response.data.msg;
          this.showSnackBar = true;
        })
        .catch((err) => {
          this.ratingLoading = false;
          console.log(err);
        });
    },
  },
};
</script>